<script>
  import { onMount } from "svelte";
  import EmailList from "../../EmailList/EmailList.svelte";
  import {External, M} from "../../external";

  export let onTemplateSelected, tab;
  let templates = [];
  let categories = null;
  let selectedCategory = 0;
  let useStaticImage = false;

  //$: load(tab);

  onMount(function () {
    load(tab);
  });

  let load = function (tab) {
    External.Tools.makeWebsiteRequest({
      action: "getEmailTemplates",
      data: {
        user: tab === "user"
      },
      onOk: function (response) {
        useStaticImage = tab !== "user";
        if (!response.data) {
          return;
        }
        setData(response.data);
      }
    });
  };

  let setData = function (newData) {
    if (tab === "user") {
      categories = null;
      templates = newData;
    } else {
      let allItemsSet = {};
      let allItems = [];
      let cats = [
        {
          name: M.ALL,
          id: 0,
          items: allItems
        }
      ];
      
      (newData || []).forEach(function (category) {
        let locale = External.userLocale === "da_JK" ? "da" : External.userLocale;
        if (External.userLocale === "zh_JO") External.usedLocale = "zh";
        locale = locale || "en";

        let name = (category.name || {})[locale] || (category.name || {})['en'] || "";

        let items = [];
        (category.items || []).forEach(function (item) {
          let emailItem = {
            staticImage: item.image,
            name: item.id
          };

          items.push(emailItem);
          if (!allItemsSet[item.id]) {
            allItemsSet[item.id] = [item.id];
            allItems.push(emailItem);
          }
        });

        let cat = {
          name: name,
          id: category.id,
          items: items
        };
        cats.push(cat);
      });

      categories = cats;
      if (cats.length > 0) {
        selectedCategory = cats[0].id;
        onCategoryChange();
      }
    }
  };

  let onCategoryChange = function () {
    for (let idx = 0; idx < categories.length; ++idx) {
      if (categories[idx].id === selectedCategory) {
        templates = {
          templates: categories[idx].items
        };
        break;
      }
    }
  };

  let onSelect = function (template) {
    onTemplateSelected(template, tab);
  };
</script>

<div class="col20 f-left padding-20">
  {#if tab !== "user" && categories !== null && categories.length}
    <div class="col20 f-left">
      <select
        bind:value={selectedCategory}
        on:change={onCategoryChange}
        style="width: 200px; float: right; margin-right: 1%; margin-top: 0;"
      >
        {#each categories as category (category.id)}
          <option value={category.id}>{category.name}</option>
        {/each}
      </select>
    </div>
  {/if}

  <EmailList data={templates} onClick={onSelect} {useStaticImage} />
</div>
